'use strict';

var zabbixUtil = require('../alarm/zabbix-util');

module.exports = /*@ngInject*/ [
    "$rootScope",
    "$scope",
    "$stateParams",
    "ProjectService",
    "SynchronizationResourceService",
    "$filter",
    "$q",
    "$timeout",
    "TimeZoneFactory",
    "NgTableParams",
    function SynchronizationMonitoringPageController(
        $rootScope,
        $scope,
        $stateParams,
        ProjectService,
        SynchronizationResourceService,
        $filter,
        $q,
        $timeout,
        TimeZoneFactory,
        NgTableParams) {

        var vm = this;

        var name = "synchronization";
        var trainId = $stateParams.trainId;
        var sync = [];

        $rootScope.$on('project-config-updated', init);

        init();

        function init() {
            $scope.$emit('init-child', name);

            var projectId = ProjectService.getSelectedProjectId();

            if (projectId) {
                getSyncData(projectId);
            }
        }

        vm.getColor = function (level) {
            return zabbixUtil.getPriorityColor(level);
        };

        function getSyncData(projectId) {
            SynchronizationResourceService.getSyncEntityData().query({
                'projectId': projectId,
                'trainId': trainId
            }).$promise.then(function (data) {
                vm.sync = data;
                data.forEach(function (sync) {
                    sync.date = TimeZoneFactory.format(sync.timestamp, 'YYYY-MM-DD HH:mm');
                    if (!!sync.latestSyncSuccess) {
                        sync.lastSuccess = TimeZoneFactory.format(sync.latestSyncSuccess, 'YYYY-MM-DD HH:mm');
                    }
                    var now = Date.now();
                    if (sync.bytesReceived === -1 && (now - sync.latestSyncSuccess > 2 * 24 * 60 * 60000)) {
                        sync.level = 5; // red
                    } else if (now - sync.timestamp > 2 * 24 * 60 * 60000) {
                        sync.level = 2; // yellow
                    } else {
                        sync.level = 0; // green
                    }
                });
            });
        }

    }];